import { showNotification } from '@mantine/notifications';

const SOMETHING_WENT_WRONG = 'Something went wrong. Please try again';

export const showAlert = (data, type = 'success') => {
  const message = data?.response?.data?.message || data?.message;

  // Define color and title based on type
  const config = {
    success: { title: 'Success', color: 'teal' },
    error: { title: 'Error', color: 'red' },
    warning: { title: 'Warning', color: '#d17e19ff' }, // amber-orange color
  };

  const { title, color } = config[type] || config.success;

  showNotification({
    title,
    message: message ? message : type === 'error' ? SOMETHING_WENT_WRONG : '',
    color,
    styles: () => ({
      title: { color },
      description: { color },
      closeButton: { color },
    }),
  });
};
